<div class="row">
    <div class="col-md-12 mt-4">
        <div class="row">
            <div class="col-lg-3">
                <mat-checkbox [(ngModel)]="AlignmentData.StudBoltsReplaced" class="">Stud Bolts Replaced?</mat-checkbox>
            </div>
            <div class="col-lg-3">
                <mat-checkbox [(ngModel)]="AlignmentData.GasketReplaced" class="">Gasket Replaced?</mat-checkbox>
            </div>
            <div class="col-lg-3">
                <mat-checkbox [(ngModel)]="AlignmentData.FlangeFaceRepairRequired" class="">Flange Face Repair Required?
                </mat-checkbox>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-3">
                <mat-checkbox [(ngModel)]="AlignmentData.PaintUnderNutRemoved" class="">Paint Under Nut
                    Removed?</mat-checkbox>
            </div>
            <div class="col-lg-3">
                <mat-checkbox [(ngModel)]="AlignmentData.CorrectStud" class="">Correct Stud?</mat-checkbox>
            </div>
            <div class="col-lg-3">
                <mat-checkbox [(ngModel)]="AlignmentData.StudsCorrectlyLubricated" class="">Studs Correctly
                    Lubricated?</mat-checkbox>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-md-12 mt-2">
        <div class="row tablepad">
            <div class="col-lg-3 col-sm-6 pe-2 ps-2 mt-2" *ngFor="let item of AlignmentData.DataList">
                <div class="activity_img_wrap">
                    <h4>{{ item.Name }}</h4>
                    <div class="images_box">
                        <img src="{{ item.ImgUrl }}" alt="" />
                    </div>
                    <div class="table-responsive">
                        <table>
                            <tr>
                                <th>0 Drg</th>
                                <td>
                                    <mat-form-field class="example-full-width" style="margin-top: 0px">
                                        <input type="text" matInput [value]="item.ZeroDrg" />
                                    </mat-form-field>
                                </td>
                            </tr>
                            <tr>
                                <th>90 Drg</th>
                                <td>
                                    <mat-form-field class="example-full-width" style="margin-top: 0px">
                                        <input type="text" matInput [value]="item.NinetyDrg" />
                                    </mat-form-field>
                                </td>
                            </tr>
                            <tr>
                                <th>180 Drg</th>
                                <td>
                                    <mat-form-field class="example-full-width" style="margin-top: 0px">
                                        <input type="text" matInput [value]="item.OneEightyDrg" />
                                    </mat-form-field>
                                </td>
                            </tr>
                            <tr>
                                <th>270 Drg</th>
                                <td>
                                    <mat-form-field class="example-full-width" style="margin-top: 0px">
                                        <input type="text" matInput [value]="item.TwoSeventyDrg" />
                                    </mat-form-field>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- </div>
<div class="modal-footer">
         
          
</div> -->